import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.topSection}>
        <div className={styles.logo}>Megaloto</div>
        <nav className={styles.nav}>
          <ul>
            <li><a href="#about">Acerca de nosotros</a></li>
            <li><a href="/login">Términos y condiciones</a></li>
            <li><a href="/login">Política de privacidad</a></li>
            <li><a href="https://wa.me/573133956853?text=Estoy%20interesado%20en%20unirme%20al%20grupo%20de%20ventas%20de%20Megaloto,%20me%20das%20m%C3%A1s%20informacion,%20por%20favor">Contacto</a></li>
          </ul>
        </nav>
      </div>

      <div className={styles.socials}>
        <p>Síguenos en:</p>
        <div className={styles.icons}>
          <a href="https://www.facebook.com/profile.php?id=61567288659704" className={styles.icon}><i className="fab fa-facebook-f"></i></a>
          {/* <a href="#twitter" className={styles.icon}><i className="fab fa-twitter"></i></a> */}
          <a href="https://www.instagram.com/megaloto.express/" className={styles.icon}><i className="fab fa-instagram"></i></a>
          {/* <a href="#youtube" className={styles.icon}><i className="fab fa-youtube"></i></a> */}
        </div>
      </div>

      <div className={styles.bottomSection}>
        <p>© 2024 Megaloto. Todos los derechos reservados.</p>
        <p className={styles.disclaimer}>
          Participar en sorteos está sujeto a las leyes locales de tu Colombia. Juega con responsabilidad.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
